import {
    Component,
    ViewEncapsulation,
    ViewContainerRef,
    ComponentFactoryResolver,
    ViewChild, AfterViewInit,
    Input,
    HostBinding
} from "@angular/core";
import { AppBannerService } from "@edp-services/app-banner.service";
import { IModalData } from "./edp-modal.models";

@Component({
    selector: "edp-modal",
    templateUrl: "./edp-modal.component.html",
    styleUrls: ["./edp-modal.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class EdpModalComponent implements AfterViewInit {
    @Input() public data: IModalData;
    @ViewChild("container", { read: ViewContainerRef, static: true }) container: ViewContainerRef;
    @HostBinding("class.opened") opened = false;
    public showAppBanner = false;

    constructor(private componentFactoryResolver: ComponentFactoryResolver, private readonly appBannerService: AppBannerService) {
        this.showAppBanner = this.appBannerService.show();
    }

    ngAfterViewInit(): void {
        setTimeout(() => (this.opened = true));
    }

    private injectComponent(component: any): void {
        this.container.clear();
        const factory = this.componentFactoryResolver.resolveComponentFactory(component);
        const componentRef = this.container.createComponent(factory);
        (componentRef.instance as any).data = this.data;
    }
}
